(function () {
  var registry = new WeakMap();
  var openInstance = null;

  function lockBody() {
    document.body.classList.add('overflow-hidden');
  }

  function unlockBody() {
    document.body.classList.remove('overflow-hidden');
  }

  function setUnit(instance, unit) {
    instance.unitButtons.forEach(function (button) {
      button.setAttribute('aria-pressed', button.getAttribute('data-444-size-guide-unit') === unit ? 'true' : 'false');
    });

    instance.tables.forEach(function (table) {
      table.hidden = table.getAttribute('data-444-size-guide-table') !== unit;
    });

    if (instance.status) {
      instance.status.textContent = unit === 'in' ? 'Inch table shown.' : 'Centimeter table shown.';
    }
  }

  function open(instance, trigger) {
    if (openInstance && openInstance !== instance) {
      close(openInstance, false);
    }

    instance.lastTrigger = trigger;
    instance.modal.hidden = false;
    if (typeof instance.modal.showModal === 'function') {
      instance.modal.showModal();
    } else {
      instance.modal.setAttribute('open', '');
    }
    instance.isOpen = true;
    openInstance = instance;
    lockBody();

    instance.dialog.focus();
  }

  function close(instance, restoreFocus) {
    if (!instance || !instance.isOpen) return;

    instance.restoreFocus = restoreFocus;
    if (typeof instance.modal.close === 'function' && instance.modal.open) {
      instance.modal.close();
    } else {
      instance.modal.removeAttribute('open');
      handleClosed(instance);
    }
  }

  function handleClosed(instance) {
    instance.modal.hidden = true;
    instance.isOpen = false;
    if (openInstance === instance) openInstance = null;
    unlockBody();

    if (instance.restoreFocus && instance.lastTrigger) {
      instance.lastTrigger.focus();
    }
    instance.restoreFocus = true;
  }

  function initGuide(container) {
    if (registry.has(container)) return;

    var trigger = container.querySelector('[data-444-size-guide-open]');
    var modal = container.querySelector('[data-444-size-guide-modal]');
    var dialog = container.querySelector('[data-444-size-guide-dialog]');
    if (!trigger || !modal || !dialog) return;

    var instance = {
      container: container,
      trigger: trigger,
      modal: modal,
      dialog: dialog,
      closeButtons: Array.prototype.slice.call(container.querySelectorAll('[data-444-size-guide-close]')),
      unitButtons: Array.prototype.slice.call(container.querySelectorAll('[data-444-size-guide-unit]')),
      tables: Array.prototype.slice.call(container.querySelectorAll('[data-444-size-guide-table]')),
      status: container.querySelector('[data-444-size-guide-status]'),
      isOpen: false,
      lastTrigger: null,
      restoreFocus: true,
    };

    instance.onOpen = function () {
      open(instance, trigger);
    };
    instance.onClose = function () {
      close(instance, true);
    };
    instance.onDialogClick = function (event) {
      if (event.target === instance.modal) close(instance, true);
    };
    instance.onDialogClose = function () {
      handleClosed(instance);
    };
    instance.onUnit = function (event) {
      setUnit(instance, event.currentTarget.getAttribute('data-444-size-guide-unit'));
    };

    trigger.addEventListener('click', instance.onOpen);
    instance.closeButtons.forEach(function (button) {
      button.addEventListener('click', instance.onClose);
    });
    instance.unitButtons.forEach(function (button) {
      button.addEventListener('click', instance.onUnit);
    });
    modal.addEventListener('click', instance.onDialogClick);
    modal.addEventListener('close', instance.onDialogClose);

    registry.set(container, instance);
  }

  function cleanupGuide(container) {
    var instance = registry.get(container);
    if (!instance) return;

    close(instance, false);
    instance.trigger.removeEventListener('click', instance.onOpen);
    instance.closeButtons.forEach(function (button) {
      button.removeEventListener('click', instance.onClose);
    });
    instance.unitButtons.forEach(function (button) {
      button.removeEventListener('click', instance.onUnit);
    });
    instance.modal.removeEventListener('click', instance.onDialogClick);
    instance.modal.removeEventListener('close', instance.onDialogClose);
    registry.delete(container);
  }

  function initAll(root) {
    var scope = root || document;
    var guides = scope.matches && scope.matches('[data-444-size-guide]')
      ? [scope]
      : Array.prototype.slice.call(scope.querySelectorAll('[data-444-size-guide]'));

    guides.forEach(initGuide);
  }

  function cleanupAll(root) {
    var scope = root || document;
    var guides = scope.matches && scope.matches('[data-444-size-guide]')
      ? [scope]
      : Array.prototype.slice.call(scope.querySelectorAll('[data-444-size-guide]'));

    guides.forEach(cleanupGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    cleanupAll(event.target);
  });
})();
